import { Text } from "@findemdev/maui";
import styled from "styled-components";

export const CopyCredentialModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.dimensions.spacing[1]};
`;

export const InputHelperText = styled(Text)`
  font-size: 14px;
`;